import { useMemo } from "react"
import { useErpConfig } from "@tm/utils"

export function useDefaultErpSystem() {
    const { erpSystemConfigs } = useErpConfig()
    return useMemo(() => erpSystemConfigs?.find((x) => x.isDefaultGetErpInfoSystem) ?? erpSystemConfigs?.[0], [erpSystemConfigs])
}
